import Layout1 from './Layout1'
import Layout2 from './Layout2'

export default { Layout1, Layout2 }
